import { observer } from 'mobx-react';
import React from 'react';
import { Combobox } from '../../../components/combobox';
import { ConfirmationModal } from '../../../components/confirmation-modal/index';
import { Api } from '../../../core/api';
import { injectTSDI } from '../../../core/tsdi';
import { CurrencyDto } from '../../../core/api/WalletClient';

type Props = {
    userId: string;
    onSuccess: () => void;
    openState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
};

export const CreateAccountModal = observer(
    ({ userId, onSuccess, openState: [open, setOpen] }: Props) => {
        const { walletClient } = injectTSDI(Api);
        const [currencies, setCurrencies] = React.useState<CurrencyDto[]>([]);
        const [selectedCurrency, setSelectedCurrency] =
            React.useState<CurrencyDto | null>(null);

        React.useEffect(() => {
            if (open) {
                walletClient.supportApi
                    .currencySupportControllerGetAllCurrencies({
                        size: 1000
                    })
                    .then((res) => setCurrencies(res.data.content));
            }
        }, [open]);

        const handleCreate = async () => {
            if (!selectedCurrency) {
                return false;
            }
            await walletClient.supportApi.accountSupportControllerCreateAccount(
                userId,
                selectedCurrency.code
            );
            setSelectedCurrency(null);
            onSuccess();
            return true;
        };

        return (
            <ConfirmationModal
                title="Create Wallet Account"
                open={open}
                submitHandler={handleCreate}
                onModalClose={() => {
                    setSelectedCurrency(null);
                    setOpen(false);
                }}
                buttonText="Create Account"
            >
                <Combobox<CurrencyDto>
                    label="Currency"
                    required
                    options={currencies}
                    value={selectedCurrency}
                    onChange={(value) => setSelectedCurrency(value)}
                    getOptionKey={(option) => option.code}
                    getOptionLabel={(option) =>
                        `${option.code} — ${option.name} (${option.symbol})`
                    }
                />
            </ConfirmationModal>
        );
    }
);
